/**
 * Parcelas vencidas agrupadas por tempo de atraso.
 */
import { formatCurrency } from '../../../../utils/obraAnalytics'

const AgingPanel = ({ aging = [], totalVencido = 0 }) => {
    const itens = (aging || []).map((a) => ({
        label: a.label,
        value: Number(a.value || 0),
    }))
    const max = Math.max(...itens.map((i) => i.value), 1)

    return (
        <div className="bg-white border border-gray-100 rounded-2xl shadow-sm overflow-hidden">
            <div className="px-5 py-4 border-b border-gray-100 flex flex-wrap items-center justify-between gap-2">
                <div>
                    <h3 className="text-sm font-bold text-gray-800">Atraso por tempo</h3>
                    <p className="text-xs text-gray-400 mt-0.5">Todos os vencidos da obra, por tempo de atraso</p>
                </div>
                <span className="text-xs font-semibold px-3 py-1 rounded-full bg-rose-50 text-rose-700 border border-rose-100">
                    Total vencido: {formatCurrency(totalVencido)}
                </span>
            </div>
            <div className="p-5 space-y-3">
                {itens.every((i) => i.value === 0) ? (
                    <p className="text-sm text-gray-400 text-center py-2">Nenhuma parcela vencida nas faixas.</p>
                ) : (
                    itens.map((item) => (
                        <div key={item.label} className="space-y-1">
                            <div className="flex items-center justify-between text-xs">
                                <span className="font-medium text-gray-600">{item.label}</span>
                                <span className="font-semibold text-rose-700 tabular-nums">{formatCurrency(item.value)}</span>
                            </div>
                            <div className="h-2 rounded-full bg-rose-50 overflow-hidden">
                                <div
                                    className="h-full rounded-full bg-rose-400 transition-all"
                                    style={{ width: `${Math.max(item.value > 0 ? 4 : 0, Math.round((item.value / max) * 100))}%` }}
                                />
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    )
}

export default AgingPanel
